export default __webpack_public_path__ + "static/media/bitcoin.f6ce2f43.svg";